import { createAsyncThunk, isPending } from '@reduxjs/toolkit';
import axios from 'axios';

import { IMaintenanceControl, defaultValue } from 'app/shared/model/maintenance-control.model';
import { EntityState, createEntitySlice, serializeAxiosError } from 'app/shared/reducers/reducer.utils';

const initialState: EntityState<IMaintenanceControl> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/maintenance-controls-active';

// Actions

export const getMaintenanceControlByTruckImplementId = createAsyncThunk(
  'maintenanceControlCustom/fetch_entity',
  async (id: string | number) => {
    const requestUrl = `${apiUrl}/truck-implement/${id}`;
    return axios.get<IMaintenanceControl>(requestUrl);
  },
  { serializeError: serializeAxiosError }
);

// slice

export const MaintenanceControlCustomSlice = createEntitySlice({
  name: 'maintenanceControlCustom',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getMaintenanceControlByTruckImplementId.fulfilled, (state, action) => {
        state.loading = false;
        state.entity = action.payload.data;
      })
      .addMatcher(isPending(getMaintenanceControlByTruckImplementId), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      });
  },
});

export const { reset } = MaintenanceControlCustomSlice.actions;

// Reducer
export default MaintenanceControlCustomSlice.reducer;
